// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import punycode from 'punycode';

const toPunycode = domain => punycode.toASCII(domain);

export { toPunycode };
